import { useMutation } from '@apollo/client'
import { DestroyItemDocument, GetProcessDetailDocument } from 'generated/resources/graphql'

export const useDestroyItem = () => {
  const [executeMutation] = useMutation(DestroyItemDocument)

  const destroyItem = async (id: string, processId: string) => {
    const { data, errors } = await executeMutation({
      variables: {
        id,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessDetailDocument,
          variables: {
            id: processId,
          },
        },
      ],
    })

    if (errors?.length || data?.processesMutations?.destroyProcessesItem?.errors.length) {
      throw (
        'Could not destroy item: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.destroyProcessesItem?.errors || []),
        ])
      )
    }
  }

  return {
    destroyItem,
  }
}
